export default __webpack_public_path__ + "static/media/ic-download.43d4b9be.svg";